class Facebook {
  constructor() {
    this._callbacks = [];
    this._permissions = [];
    ['getLoginStatus', 'login', 'ui', 'api'].forEach(method => {
      this[method] = (...args) => {
        // console.log('FB API:', !!this._initialized, method, args);
        if (this._initialized) this.FB[method](...args);
        else this._callbacks.push(() => this.FB[method](...args));
      };
    });
    this._init();
  }

  getLoginHandler(success, error) {
    // this.loadPermissions();
    return () => {
      this.getLoginStatus(response => {
        if (response.status === 'connected') {
          success && success(response.authResponse);
        } else {
          this.login(
            response => {
              if (response.status === 'connected') {
                success && success(response.authResponse);
              } else {
                error && error(response.authResponse);
              }
            },
            { scope: 'email' },
          );
        }
      });
    };
  }

  //   loadPermissions() {
  //     if (this._loadingPermissions || this._loadedPermissions) return;
  //     this._loadingPermissions = true;
  //     this.getLoginStatus(resp => {
  //       if (resp.status === 'connected') {
  //         this.api(
  //           `/${resp.authResponse.userID}/permissions`,
  //           'GET',
  //           { access_token: resp.authResponse.accessToken },
  //           resp => {
  //             this._permissions = resp.data;
  //             this._loadedPermissions = true;
  //             // const fbPermissions = resp.data.map(p => p.permission); // .filter(p => p.status === 'granted')
  //             // this.setState({ fbPermissions })
  //           }
  //         );
  //       }
  //     });
  //   }
  //
  //   requestedPermissions() {
  //     return this._permissions.map(p => p.permission);
  //   }
  //   grantedPermissions() {
  //     return this._permissions.filter(p => p.status === 'granted').map(p => p.permission);
  //   }

  _init() {
    window.fbAsyncInit = () => {
      this._initialized = true;
      this.FB = window.FB;
      this.FB.init({
        version: process.env.FB_API_VERSION || 'v23.0',
        appId: process.env.FB_APP_ID,
      });
      this._callbacks.forEach(cb => cb());
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js';
      // js.src = '//connect.facebook.net/en_US/sdk/debug.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }
}

export default new Facebook();
